import React, { Fragment, useState } from 'react';
import { Menu, Transition } from '@headlessui/react';
import toast from 'react-hot-toast';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import downloadReport from '../../utils/downloadReport';

// One "Download" button with a menu of options, each
// { label, description, path, fallbackName } for a CSV, or
// { label, description, onSelect } for a custom action (e.g. the PDF).
function DownloadMenu({ options, label = 'Download' }) {
  const [busy, setBusy] = useState(null);

  const run = async (option) => {
    if (option.onSelect) {
      option.onSelect();
      return;
    }
    setBusy(option.label);
    try {
      await downloadReport(option.path, option.fallbackName);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setBusy(null);
    }
  };

  return (
    <Menu as="div" className="relative">
      <Menu.Button
        disabled={Boolean(busy)}
        className="inline-flex items-center gap-1 border border-gray-300 bg-white hover:border-gray-400 px-3 py-1.5 rounded-md text-gray-800 text-sm disabled:opacity-60"
      >
        {busy ? (
          <span className="h-3.5 w-3.5 rounded-full border-2 border-gray-300 border-t-claret-500 animate-spin" />
        ) : (
          <FileDownloadOutlinedIcon fontSize="small" />
        )}
        <span>{busy ? 'Preparing…' : label}</span>
        <KeyboardArrowDownIcon fontSize="small" className="text-gray-400" />
      </Menu.Button>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="opacity-0 scale-95"
        enterTo="opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="opacity-100 scale-100"
        leaveTo="opacity-0 scale-95"
      >
        <Menu.Items className="absolute right-0 z-20 mt-1 w-64 origin-top-right rounded-lg border border-gray-200 bg-white p-1 shadow-lg focus:outline-none">
          {options.map((option) => (
            <Menu.Item key={option.label}>
              {({ active }) => (
                <button
                  type="button"
                  onClick={() => run(option)}
                  className={`w-full rounded-md px-3 py-2 text-left ${
                    active ? 'bg-gray-50' : ''
                  }`}
                >
                  <span className="block text-sm text-gray-900">
                    {option.label}
                  </span>
                  {option.description && (
                    <span className="block text-xs text-gray-500">
                      {option.description}
                    </span>
                  )}
                </button>
              )}
            </Menu.Item>
          ))}
        </Menu.Items>
      </Transition>
    </Menu>
  );
}

export default DownloadMenu;
